<template>
  <v-row dense>
    <v-col>
      <navigation-drawer
        color="white"
        :depth="1"
        permanent
        clipped
        fixed
        class="pt-4"
      >
        <v-list dense class="mb-10">
          <v-list-item dense class="px-0 mb-10">
            <v-timeline dense>
              <v-timeline-item
                v-for="item in surgeryIndicationsByDate"
                :key="item.date"
                :color="item.date === date ? 'primary' : 'gray lighten-1'"
                small
              >
                <v-row dense>
                  <v-col>
                    <v-btn text block small @click="date = item.date">
                      {{ item.date }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </v-list-item>
        </v-list>
      </navigation-drawer>
    </v-col>

    <v-col style="padding-left: 170px" cols="12">
      <v-row align="center">
        <v-col class="text-h3 gray--text text--lighten-1" cols="auto">
          Indicações Cirúrgicas
        </v-col>
      </v-row>
      <div v-if="!lodash.isEmpty(filteredSurgeryIndicationsByDate)">
        <v-row
          v-for="surgeryIndication in filteredSurgeryIndicationsByDate"
          :key="surgeryIndication.id"
        >
          <SurgeryIndicationListItem
            :attendance="lodash.first(surgeryIndication.attendances)"
            :surgeryIndication="surgeryIndication"
          />
        </v-row>
      </div>
      <div v-else>
        <v-row justify="center">
          <v-col cols="4">
            <v-alert color="orange" outlined text type="info">
              Sem Indicações Cirúrgicas
            </v-alert>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import SurgeryIndicationListItem from "@/components/surgery_indication/list/item.vue";
import SURGERY_INDICATIONS_BY_DATE from "@/graphql/patient_information/surgery_indication_by_date.gql";

export default {
  name: "PatientSurgeryIndication",
  props: {
    patient: Object,
  },
  components: {
    SurgeryIndicationListItem,
  },
  data() {
    return {
      date: "",
      filteredSurgeryIndicationsByDate: [],
    };
  },
  apollo: {
    surgeryIndicationsByDate: {
      query: SURGERY_INDICATIONS_BY_DATE,
      variables() {
        return {
          patientId: this.patient.id,
        };
      },
      update(data) {
        return data.patientSurgeryIndicationsByDate;
      },
      result({ data }) {
        if (this.lodash.isEmpty(data.patientSurgeryIndicationsByDate)) return;
        
        this.date = this.lodash.first(
          data.patientSurgeryIndicationsByDate
        ).date;

        this.filteredSurgeryIndicationsByDate = this.lodash.first(
          data.patientSurgeryIndicationsByDate
        ).surgeryIndications;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation-drawer {
  width: 15%;
}

.content-area {
  width: 85;
}
</style>
